module.exports = __webpack_public_path__ + "img/freelancer.d92533d8.png";